export const setFormFile = (e) => {

    return function (dispatch) {

        dispatch({
            type: 'FORM_FILE',
            payload:  e.target.files[0]
        })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/setFormFile.js